import React, { Component, MouseEvent } from "react";
import cat from "./cute-grey-cat.jpeg"
import dog from "./I4UWBNZ5O5ESTG4DDJ6JEUJ43U.jpg"

type ResultPageProps = {
    // asks parent to begin quiz
    onRestartClick: () => void;

    // score
    score: number[];
}

export class ResultPage extends Component<ResultPageProps> {
    render = (): JSX.Element => {
        return (
            <div>
                <h1>{this.renderResult()}</h1>
                <button type="button" onClick={this.doRestartClick}>Restart Quiz</button>
            </div>
        );
    }

    // Updates UI to quiz page
    doRestartClick = (_evt: MouseEvent<HTMLButtonElement>): void => {
        this.props.onRestartClick();
    }

    // Display result
    renderResult = (): JSX.Element => {
        if (this.props.score[0] > this.props.score[1]) {
            return (
                <div>
                    <h1>You are a cat!</h1>
                    <p></p>
                    <img src={cat} className="cat" alt="cat"/>
                    <p className="body">
                        Cats tend to be more introverted and prefer calm and quiet. They prefer
                        tranquility to loud areas.
                    </p>
                </div>
            );
        } else {
            return (
                <div>
                    <h1>You are a dog!</h1>
                    <p></p>
                    <img src={dog} className="dog" alt="dog"/>
                    <p className="body">
                        Dogs tend to be more extroverted and love to explore. They don't mind a little
                        noise and love team sports.
                    </p>
                </div>
            )
        }
    }
}